import { put, select, takeLatest } from 'redux-saga/effects'

import ActionsTypes from '../../constants/ActionsTypes'

import { globalLoadingActionCreators, errorManagerActionCreators, tableActionCreators } from '../actions'

import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const setSavedTableColumnsDisplay = function* ({ payload }) {
	const bodyMsg = payload.column
	const user = yield select(selectIdsUser)
	const apiCall = R.SET_SAVED_TABLE_COLUMNS_DISPLAY()

	//yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMsg)

		yield put(tableActionCreators.setSavedTableColumnsDisplaySuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(tableActionCreators.setSavedTableColumnsDisplayFailure(e.response))
	} finally {
		//yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY, setSavedTableColumnsDisplay)
}

export default sagas
